import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/layouts/default.vue").then(m => m.default || m)),
  generic: defineAsyncComponent(() => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/layouts/generic.vue").then(m => m.default || m))
}